import React from "react";
import CyberLawIcon from "./icon";
import CyberLawBody from "./body";
import "./style.css";

const CyberLawBtn = () => {
  return (
    <>
      <CyberLawIcon />
      <CyberLawBody />
    </>
  );
};

export default CyberLawBtn;
